module.exports = __webpack_public_path__ + "media/application/images/page-content-bg-8ec8a4b50241a2193a7923e4c5189b8c.jpg";